export function NotFound() {
  return (
    <main class="mx-auto flex min-h-(--fv-screen) max-w-md flex-col items-start justify-center gap-3 px-6">
      <p class="text-sm font-semibold uppercase tracking-wider text-muted">Floor Visualizer</p>
      <h1 class="text-3xl font-bold leading-tight">We couldn't find this visualizer</h1>
      <p class="text-muted">The link may be mistyped or no longer active. Please check the address, or contact the company that sent it to you.</p>
    </main>
  );
}
